/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddShopReferralRequestBody } from '../models/AddShopReferralRequestBody';
import type { DeleteShopReferralRequestBody } from '../models/DeleteShopReferralRequestBody';
import type { GetShopReferredResponse } from '../models/GetShopReferredResponse';
import type { GetShopReferrerResponse } from '../models/GetShopReferrerResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ReferralService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns any OK
     * @throws ApiError
     */
    public addReferral({
        requestBody,
    }: {
        requestBody: AddShopReferralRequestBody,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/referral',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public deleteReferral({
        requestBody,
    }: {
        requestBody: DeleteShopReferralRequestBody,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v2/referral',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns GetShopReferrerResponse OK
     * @throws ApiError
     */
    public getShopReferrer({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<GetShopReferrerResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/referral/referrer',
            query: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns GetShopReferredResponse OK
     * @throws ApiError
     */
    public getShopReferred({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<GetShopReferredResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/referral/referred',
            query: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
